import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { RoleAvailabilityService } from '../models/roleavailability.service';
import { RoleAvailabilityModel } from '../models/roleavailability.model';
import { CustomerService } from '../../customer/models/customer.service';
import { RoleModel } from '../../role-management/models/role.model';
import { retry } from 'rxjs/operator/retry';

@Component({
  selector: 'wego-roleavailability',
  template: require('../views/roleavailability-list.component.html'),
  providers: [RoleAvailabilityService, CustomerService],
})

export class RoleAvailabilityListComponent implements OnInit {
  listModule: string;
  breadCrumbTitle: string;
  sub: any;
  DataListModel: DataListModel;
  roleAvailabilityList: RoleAvailabilityModel[];
  apiErrorMsg: string;
  isLoading: boolean;
  customerHashId: string;
  customerName: string;
  roleAvailabilityHashId: string;
  message: string;
  urlDefaultPage: string;
  urlRoleAvailabilityUpdate: string;
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  private popupTitle: string;
  private validationMessage: string;
  urlCustomer: string;
  @ViewChild('confirmModel') public confirmModel: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('roleAvailabilityModal') public roleAvailabilityModal: any;
  @ViewChild('alertModal') public alertModal: ModalDirective;
  @ViewChild('AssignRole') public AssignRole: ModalDirective;
  @ViewChild('saveRoleAvailabilityModal') public saveRoleAvailabilityModal: any;
  constructor(private roleAvailabilityService: RoleAvailabilityService
    , private customerService: CustomerService
    , private authService: AuthService
    , private activeRoute: ActivatedRoute
    , private translate: TranslateService) {
  }

  ngOnInit() {
    this.listModule = this.translate.instant('LblCustomer');
    this.module = this.translate.instant('LblRoleAvailability');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["internalRoleName", "entity", "roleType", "presentationName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlCustomer = this.authService.GetURL(ApplicationRouteURL.URL_CUSTOMER_LIST);
    this.breadCrumbTitle = this.translate.instant('LblListPage', [this.module]);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.listModule]);
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.customerHashId = params['customerHashId'] || '';
        this.GetCustomerDetails();
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.RoleAvailabilityList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.RoleAvailabilityList();
  }

  public OnPageChanged(event: any) {
    this.DataListModel.currentPage = event.page;
    this.RoleAvailabilityList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.RoleAvailabilityList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.roleAvailabilityService.ExportRoleAvailability(this.DataListModel, this.customerHashId)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "RoleAvailability" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public RoleAvailabilityList() {
    this.isLoading = true;
    if (this.customerHashId) {
      this.roleAvailabilityService.GetAllRoleAvailability(this.DataListModel, this.customerHashId)
        .subscribe(
        res => {
          this.roleAvailabilityList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

  public GetCustomerDetails() {
    if (this.customerHashId) {
      this.isLoading = true;
      this.customerService.GetCustomerBasicDetail(this.customerHashId)
        .subscribe(
        res => {
          if (res.data) {
            this.customerName = res.data.entityName;
            this.RoleAvailabilityList();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

  public DeleteRoleAvailability(roleAvailabilityHashId: string) {
    this.isLoading = true;
    this.roleAvailabilityService.DeleteRoleAvailability(roleAvailabilityHashId)
      .subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.RoleAvailabilityList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.validationMessage = res.error;
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowAlertModal();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowConfirmModel(roleAvailabilityHashId?: string): void {
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
    this.roleAvailabilityHashId = roleAvailabilityHashId;
    this.confirmModel.show();
  }

  public HideConfirmModel(): void {
    this.roleAvailabilityHashId = "";
    this.confirmModel.hide();
  }

  public SuccessModalClick(): void {
    this.DeleteRoleAvailability(this.roleAvailabilityHashId);
    this.HideConfirmModel();
  }

  public UpdateRoleAvailability(roleavailability: any): void {
    this.roleAvailabilityModal.model = JSON.parse(JSON.stringify(roleavailability));
    this.roleAvailabilityModal.errorModel = [];
    this.roleAvailabilityModal.show();
  }

  public SuccessUpdateRoleAvailability($event: any) {
    this.popupMsg = this.translate.instant('LblRecordUpdatedSuccess', [this.module]);
    this.ShowSuccessPopup();
    this.RoleAvailabilityList();
  }

  public HideUpdateRoleAvailability(): void {
    this.roleAvailabilityModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
  }

  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }

  public ShowAssignRoleAvailability(): void {
    this.AssignRole.show();
  }

  public SuccessAddRoleModalClick($event: any) {
    let selectedRoleList: RoleModel[] = $event.RoleModelList;
    if (selectedRoleList && selectedRoleList.length > 0) {
      let roleAvailabiltyList = selectedRoleList.map(x => {
        let roleAvailability = new RoleAvailabilityModel();
        roleAvailability.internalRoleName = x.roleName;
        roleAvailability.presentationName = x.roleName;
        roleAvailability.entity = x.entity;
        roleAvailability.isDefault = x.isDefault;
        roleAvailability.roleType = x.roleType;
        roleAvailability.customerHashId = this.customerHashId;
        roleAvailability.roleHashId = x.roleHashId;
        return roleAvailability;
      }
      );
      this.SaveRoleAvailability(roleAvailabiltyList);
    }
  }

  public SaveRoleAvailability(roleavailabilityList: any): void {
    this.saveRoleAvailabilityModal.model = roleavailabilityList;
    this.saveRoleAvailabilityModal.show();
  }

  public SuccessSaveRoleAvailability() {
    this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
    this.ShowSuccessPopup();
    this.RoleAvailabilityList();
  }

  public HideSaveRoleAvailability(): void {
    this.saveRoleAvailabilityModal.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/roleavailability/components/roleavailability-list.component.ts